import React from 'react';

export default function MainLayout({ children }) { 
  return (
    <>
      {children} 
    </>
  );
}
